import { isAdminHostname } from "@/shared/tenant/getTenantFromHostname";

/** True when the app is served from an admin subdomain (e.g. `admin.qa.olivelabs.ai`). */
export function useIsAdminHost(): boolean {
  return isAdminHostname(window.location.hostname);
}
